import axiosInstance from "./axiosInstance";

export interface VenueListQuery {
  searchText?: string | null;
  venueName?: string | null;
  isActive?: boolean | null;
  timezone?: string | null;
  pageNo?: number;
  pageSize?: number;
}

export interface ApiVenueListItem {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description?: string;
  timeZone: string;
  isActive: boolean;
}

export interface VenueListResponse {
  items: ApiVenueListItem[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}

export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getVenuesList = async (
  query: VenueListQuery
): Promise<VenueListResponse> => {
  const res = await axiosInstance.get("/Venues/list", {
    params: query,
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getVenuesOptions = async () => {
  const res = await axiosInstance.get("/Venues?onlyActive=true", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const addVenue = async (payload: {
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description?: string;
  timeZone: string;
  isActive: boolean;
  createdBy: number;
}) => {
  const res = await axiosInstance.post("/Venues", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const updateVenue = async (payload: {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description?: string;
  timeZone: string;
  isActive: boolean;
  updatedBy: number;
}) => {
  const res = await axiosInstance.put("/Venues", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

